// Librerias
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { Observable } from 'rxjs';

import { ApiGeolocationInterface } from '@api/_api/api-geolocation/models/api-geolocation.interface';
import { Position } from '@api/geolocation/models/position.interface';
import { CommonWindow } from '@core/domain/models/common-window.model';
import { ConfigService } from '@core/infrastructure/config/config.service';
import { HttpRequestsService } from '@core/infrastructure/http-requests/http-requests.service';
import { CorePlatformService } from '@core/infrastructure/platform/platform.service';

/**
 * Servicio para obtener datos de la API sobre geolicalización
 */
@Injectable()
export class ApiGeolocationService implements ApiGeolocationInterface {
    constructor(
        @Inject(WINDOW) private readonly window: CommonWindow,
        private readonly configService: ConfigService,
        private readonly http: HttpClient,
        private readonly apiRequestService: HttpRequestsService,
        private readonly platformService: CorePlatformService
    ) {}

    /**
     * Ontiene unas coordenadas en base a una geoposición
     * @returns Obervable de tipo "Position" con las coordenadas
     */
    public getCoordinatesFromGeoPosition(): Observable<Position> {
        if (this.platformService.isBrowser()) {
            return new Observable((observer) => {
                this.window.navigator.geolocation.getCurrentPosition(
                    (position: Position) => {
                        observer.next(position);
                        observer.complete();
                    },
                    (error) => { observer.error(error); }
                );
            });
        }
    }

    public getCoordinatesFromAPI(): Observable<any> {
        const baseUrl = this.configService.getConfigUrl<string>('baseUrl');
        const url = `${baseUrl}/user-location-detection`;
        return this.http.get(url);
    }
}
